import React from 'react';
import OrderManagementListPageContainer from './OrderManagementListPageContainer';

export class OrderManagementListPage extends React.Component{
    render(){
        return(
            <OrderManagementListPageContainer {...this.props}/>
        )
    }
}